import PropTypes from "prop-types";


export default function FaqComponentView(props) {

    return (
        <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
            <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow">
                {props.faqData.map((value, index) => {
                    return (
                        <details className="wp-block-details is-layout-flow wp-block-details-is-layout-flow my-4">
                            <summary>
                                <strong style={{ "color": `${value.isHighlighted ? "red" : "#000"}` }}>{value.question}</strong>
                            </summary>
                            <p className="scroll-offset">{value.answer}</p>
                        </details>
                    )
                })}

            </div>
        </div>
    )
}

FaqComponentView.propTypes = {
    faqData: PropTypes.array.isRequired,

}